import React, {useEffect} from 'react';

interface ErrorToastProps {
    message: string;
    clearError: () => void;
}

const ErrorToast: React.FC<ErrorToastProps> = ({ message, clearError }) => {
    useEffect(() => {
        if (!message) return;

        const timer = setTimeout(() => {
            clearError();
        }, 5000);

        return () => clearTimeout(timer);
    }, [message, clearError]);

    if (!message) return null;

    return (
        <div
            role="alert"
            className="fixed top-16 right-4 bg-red-600 text-white px-4 py-2 rounded-lg shadow-lg max-w-sm z-50"
        >
            <p>{message}</p>
        </div>
    );
};

export default ErrorToast;